/**
 * API & TanStack Query 관련 상수
 *
 * QueryClient 설정, 캐시 정책, 재시도 설정 등
 */

export const API_CONSTANTS = {
  /**
   * Query 데이터가 fresh로 간주되는 시간 (5분)
   *
   * 이 시간 동안은 refetch가 발생하지 않음
   * @see https://tanstack.com/query/latest/docs/framework/react/guides/important-defaults
   */
  STALE_TIME_MS: 5 * 60 * 1000,

  /**
   * Query 캐시 보존 시간 (10분)
   *
   * 컴포넌트 언마운트 후에도 이 시간 동안 캐시 유지
   */
  GC_TIME_MS: 10 * 60 * 1000,

  /**
   * Query 요청 실패 시 재시도 횟수
   *
   * 네트워크 일시적 오류 대응
   */
  QUERY_RETRY_COUNT: 1,

  /**
   * Mutation 요청 실패 시 재시도 횟수
   *
   * 0으로 설정하여 중복 실행 방지 (결제, 등록 등)
   */
  MUTATION_RETRY_COUNT: 0,

  /**
   * API 요청 기본 타임아웃 (10초)
   *
   * Axios 인스턴스에서 사용
   */
  REQUEST_TIMEOUT_MS: 10_000,
} as const;

/**
 * 카테고리별 staleTime 설정
 *
 * 자주 변경되지 않는 데이터는 더 긴 캐시 시간 사용
 */
export const STALE_TIME_BY_CATEGORY = {
  /** 일반 API 데이터 (5분) */
  DEFAULT: API_CONSTANTS.STALE_TIME_MS,

  /** 사용자 정보 (5분) - 프로필 수정 가능 */
  USER: 5 * 60 * 1000,

  /** 카테고리 목록 (10분) - 거의 변경되지 않음 */
  CATEGORIES: 10 * 60 * 1000,

  /** 정적 데이터 (30분) - 설정, 메타데이터 등 */
  STATIC: 30 * 60 * 1000,
} as const;
